'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:WorkspacesShowCtrl
 * @description
 * # WorkspacesShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('WorkspacesShowCtrl', [
    '$scope', 'Workspace', '$stateParams', function ($scope, Workspace, $stateParams) {
      $scope.workspace = {};
      Workspace.find($stateParams.workspacesId).then(function(response) {
        $scope.workspace = response.data;
        $scope.employees = response.data.employees;
      }, function(error) {
        Workspace.error(error);
      });
  }]);
